import React from 'react';
import './LimitReachedModal.css';

const LimitReachedModal = ({ 
  limitType = 'creatives', 
  used = 0, 
  limit = 10, 
  tariffName = 'Trial',
  onUpgrade, 
  onClose 
}) => {
  const getLimitInfo = () => {
    const types = {
      creatives: {
        icon: '🎨',
        title: 'Достигнут лимит креативов',
        description: 'Вы использовали все доступные креативы в этом месяце'
      },
      publications: {
        icon: '📱',
        title: 'Достигнут лимит публикаций',
        description: 'Вы использовали все доступные публикации в этом месяце'
      },
      counterparties: {
        icon: '👥',
        title: 'Достигнут лимит контрагентов',
        description: 'Вы добавили максимальное количество контрагентов'
      },
      contracts: {
        icon: '📄',
        title: 'Достигнут лимит договоров',
        description: 'Вы создали максимальное количество договоров'
      }
    };
    
    return types[limitType] || types.creatives;
  };

  const info = getLimitInfo();

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="limit-modal-overlay" onClick={handleOverlayClick}>
      <div className="limit-modal">
        <button className="limit-modal-close" onClick={onClose}>
          ×
        </button>

        <div className="limit-modal-icon">{info.icon}</div>
        
        <h2 className="limit-modal-title">{info.title}</h2>
        
        <p className="limit-modal-text">
          Использовано <strong>{used} из {limit}</strong>
        </p>
        
        <p className="limit-modal-description">
          {info.description}
        </p>

        <div className="limit-modal-upgrade-card">
          <div className="upgrade-card-header">
            <span className="upgrade-card-icon">🚀</span>
            <span className="upgrade-card-label">Решение</span>
          </div>
          <p className="upgrade-card-text">
            Обновите тариф, чтобы получить:
          </p>
          <ul className="upgrade-card-benefits">
            <li>✅ Больше {limitType === 'creatives' ? 'креативов' : 'возможностей'} в месяц</li>
            <li>✅ Расширенную аналитику</li>
            <li>✅ Приоритетную поддержку</li>
            <li>✅ API доступ (тариф Pro)</li>
          </ul>
        </div>

        <div className="limit-modal-actions">
          <button className="limit-modal-upgrade" onClick={onUpgrade}>
            🚀 Обновить тариф
          </button>
          <button className="limit-modal-cancel" onClick={onClose}>
            Позже
          </button>
        </div>

        <p className="limit-modal-note">
          Тариф <strong>{tariffName}</strong> • Лимиты обновятся 1 числа следующего месяца
        </p>
      </div>
    </div>
  );
};

export default LimitReachedModal;

